import { Link } from "react-router";

import { BugIcon } from "lucide-react";

export function BugTrackerLogo() {
  return (
    <Link to="/" className="flex shrink-0 items-center gap-2 text-foreground">
      <BugIcon className="size-5 text-primary" />
      <span className="font-heading text-sm font-semibold tracking-wider uppercase">BugTracker</span>
    </Link>
  );
}

interface AuthLayoutProps {
  children: React.ReactNode;
  maxWidth?: string;
  centerContent?: boolean;
}

export function AuthLayout({ children, maxWidth = "max-w-md", centerContent = true }: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-muted">
      <header className="sticky top-0 z-40 w-full border-b border-border bg-background/95 backdrop-blur-sm">
        <div className="mx-auto flex h-14 max-w-7xl items-center px-4 sm:px-6">
          <BugTrackerLogo />
        </div>
      </header>
      <main className={`flex flex-1 ${centerContent ? "items-center" : "items-start"} justify-center px-4 py-12 sm:px-6`}>
        <div className={`w-full ${maxWidth}`}>{children}</div>
      </main>
    </div>
  );
}
